import { Select, Radio, Form } from "antd";
import React, { useMemo } from "react";

const ContractRangeSelectors = ({
  enableQuarter = false,
  value = {},
  onChange,
}) => {
  const startDate = localStorage.getItem("Contract-startDate");
  const endDate = localStorage.getItem("Contract-endDate");

  const startYear = startDate ? new Date(startDate).getFullYear() : null;
  const endYear = endDate ? new Date(endDate).getFullYear() : null;

  const yearOptions = useMemo(() => {
    if (!startYear || !endYear) return [];
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => {
      const year = startYear + i;
      return { label: year.toString(), value: year };
    });
  }, [startYear, endYear]);

  const months = useMemo(() => {
    if (!value.year || !startDate || !endDate) return [];
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let startMonth = 0,
      endMonth = 11;
    if (value.year === startYear) startMonth = new Date(startDate).getMonth();
    if (value.year === endYear) endMonth = new Date(endDate).getMonth();
    return monthNames
      .map((name, i) => ({ label: name, value: i + 1 }))
      .filter((m) => m.value - 1 >= startMonth && m.value - 1 <= endMonth);
  }, [value.year, startYear, endYear, startDate, endDate]);

  const quarters = useMemo(() => {
    if (!value.year || !enableQuarter || !startDate || !endDate) return [];
    const list = [
      { label: "Q1 (Jan - Mar)", value: 1 },
      { label: "Q2 (Apr - Jun)", value: 2 },
      { label: "Q3 (Jul - Sep)", value: 3 },
      { label: "Q4 (Oct - Dec)", value: 4 },
    ];
    let startQ = 1,
      endQ = 4;
    if (value.year === startYear)
      startQ = Math.floor(new Date(startDate).getMonth() / 3) + 1;
    if (value.year === endYear)
      endQ = Math.floor(new Date(endDate).getMonth() / 3) + 1;
    return list.filter((q) => q.value >= startQ && q.value <= endQ);
  }, [value.year, startYear, endYear, startDate, endDate, enableQuarter]);

  if (!startDate || !endDate) return null;

  const periodType = value.periodType || "Month";

  const handleYearChange = (year) =>
    onChange?.({ ...value, year, month: undefined, quarter: undefined });
  const handleMonthChange = (month) =>
    onChange?.({ ...value, month, quarter: undefined });
  const handleQuarterChange = (quarter) =>
    onChange?.({ ...value, quarter, month: undefined });
  const handlePeriodTypeChange = (e) =>
    onChange?.({
      ...value,
      periodType: e.target.value,
      month: undefined,
      quarter: undefined,
    });

  return (
    <>
      <Form.Item className="mb-0" style={{ width: 200 }}>
        <Select
          placeholder="Select Year"
          options={yearOptions}
          value={value.year}
          onChange={handleYearChange}
          allowClear
        />
      </Form.Item>

      {periodType === "Quarter" ? (
        <Form.Item className="mb-0" style={{ width: 200 }}>
          <Select
            placeholder="Select Quarter"
            options={quarters}
            value={value.quarter}
            onChange={handleQuarterChange}
            disabled={!value.year}
            allowClear
          />
        </Form.Item>
      ) : (
        <Form.Item className="mb-0" style={{ width: 200 }}>
          <Select
            placeholder="Select Month"
            options={months}
            value={value.month}
            onChange={handleMonthChange}
            disabled={!value.year}
            allowClear
          />
        </Form.Item>
      )}

      {enableQuarter && (
        <Form.Item
          className="mb-0 month-quarter-radio-group"
          style={{ width: 200 }}
        >
          <Radio.Group onChange={handlePeriodTypeChange} value={periodType}>
            <Radio.Button value="Month">Month</Radio.Button>
            <Radio.Button value="Quarter">Quarter</Radio.Button>
          </Radio.Group>
        </Form.Item>
      )}
    </>
  );
};

export default ContractRangeSelectors;
